import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/VIPMP/VIPMP/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "transfer-subscriptions"
    }}>{`Transfer subscriptions`}</h1>
    <p>{`Use the `}<inlineCode parentName="p">{`POST /v3/memberships/<membership-id>/transfers`}</inlineCode>{` API endpoint to transfer subscriptions from VIP to VIP-MP.`}</p>
    <h2 {...{
      "id": "request-header"
    }}>{`Request header`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`X-Request-Id`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A unique identifier for the call. The value should be reset for every single request. If this is not provided, then a request ID will be automatically generated. Using a duplicate request ID may return an error.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`X-Correlation-Id`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Required`}</strong>{`. A unique identifier for the call. This is to ensure idempotency. In the case of a timeout, the retry call could include the same value. Upon receiving some response, the value should be reset for the next call.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Accept`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Required`}</strong>{`. Specifies the response type. Must be "application/json" for proper usage.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Content-Type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Required`}</strong>{`. Specifies the request type. Must be "application/json" for proper usage.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Authorization`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Required`}</strong>{`. Authorization token in the form `}<inlineCode parentName="td">{`Bearer <token>`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`X-Api-Key`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Required`}</strong>{`. The API Key for your integration`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "query-parameters"
    }}>{`Query parameters`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Parameter`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Values`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`ignore-order-return`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`true or false`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`false`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If `}<inlineCode parentName="td">{`true`}</inlineCode>{`, customers with returnable purchases can be transferred. `}<br />{` `}<strong parentName="td">{`Note:`}</strong>{` Setting it to `}<inlineCode parentName="td">{`true`}</inlineCode>{` will disable rollback to VIP and the “returnable” purchase can no longer be returned.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`expire-open-pas`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`true or false`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`false`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If `}<inlineCode parentName="td">{`true`}</inlineCode>{`, customers with open purchase authorizations can be transferred. Any open purchase authorizations will expire during the async portion of the transfer.`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "request-body"
    }}>{`Request body`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "resellerId": "999888777"
}
`}</code></pre>
    <h2 {...{
      "id": "response-body"
    }}>{`Response body`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "transferId": "5555luaigdfads555",
  "customerId": "",
  "membershipId": "12345678",
  "resellerId": "999888777",
  "creationDate": "2019-12-10T22:49:55Z",
  "status": "1002",
  "lineItems": [
    {
      "lineItemNumber": 1,
      "offerId": "12345678CA01A12",
      "currencyCode": "USD",
      "quantity": 10,
      "subscriptionId": ""
    }
  ],
  "links": {
    "self": {
      "uri": "/v3/memberships/12345678/transfers/5555luaigdfads555",
      "method": "GET",
      "headers": []
    }
  }
}
`}</code></pre>
    <h2 {...{
      "id": "http-status-codes"
    }}>{`HTTP status codes`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Status code`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`202`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Transfer request received or initiated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`400`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Bad request`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`401`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Invalid Authorization token`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`403`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Invalid API Key`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`404`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Invalid membership ID or reseller ID`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      